<div class="row">
  <div class="col-12">
    <h2>{{ 'Add a new child' | translate }}</h2>
    <h3></h3>
  </div>
</div>
<app-partner-form [partner]='child' [isChild]="true" (evntFormValid)="onChildFormValid()" (evntFormInvalid)="onChildFormInvalid()"></app-partner-form>
<div class="row">
  <app-waiver-checkbox [(partner)]="parent"></app-waiver-checkbox>
</div>
<div class="row">
  <div class="col-5">
    <app-button [title]="'Cancel' | translate" [buttonCssClass]="'group_button_2'" (click)="cancelClick()"></app-button>
  </div>
  <div class="col-2">
  </div>
  <div class="col-5">
    <app-button [title]="'Save' | translate" [buttonCssClass]="'group_button_1'" (clickEvent)="saveClick()" [disabled]="!isSaveButtonEnabled"></app-button>
  </div>
</div>
